/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * Meeting BaaS API
 * OpenAPI spec version: 1.1
 */

/**
 * Example usage for frontend developers

```ignore // How to use in your API handler: let status = calculate_bot_status(bot.errors, bot.ended_at, bot.duration, bot.created_at); let status_response = status_to_response(status);

// How to sort by priority: bots.sort_by_key(|bot| bot.status.sort_priority);

// How to filter by type: let errors = bots.filter(|bot| bot.status.r#type == "error");

// How to filter by category: let connection_errors = bots.filter(|bot| bot.status.category == "connection_error"); ```
 */
export type UserReportedErrorStatus =
  (typeof UserReportedErrorStatus)[keyof typeof UserReportedErrorStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserReportedErrorStatus = {
  open: "open",
  in_progress: "in_progress",
  closed: "closed"
} as const
